import React, { useState } from "react";
import { BsPlus } from "react-icons/bs";
import FormPopup from "FormModal/FormModal";
import PreviewSystemPromptsModal from "views/admin/tables/system-prompts/components/preview-system-prompts-modal/previewSystemPromptsModal";
import { useGlobalContext } from "context/globalContext";
import { consoleLog } from "helpers";

function CardMenu(props) {
  const { transparent } = props;
  const [open, setOpen] = useState(false);
  const { isOpenSystemPrompsPreviewModal, setIsOpenSystemPromptsPreviewModal } =
    useGlobalContext();
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleFormOpen = () => {
    setIsFormOpen(true);
  };
  const handleFormClose = () => {
    setIsFormOpen(false);
  };
  const handleFormSubmit = (formData) => {
    consoleLog(["Form submitted:", formData]);
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          setOpen(!open);
          handleFormOpen();
        }}
        className={`flex items-center text-xl hover:cursor-pointer ${
          transparent
            ? "bg-none text-white hover:bg-none active:bg-none"
            : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-gray-10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
        } linear justify-center rounded-lg font-bold transition duration-200`}
      >
        <BsPlus className="fill-amber-900" />
      </button>
      <FormPopup
        isOpen={isFormOpen}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
        isEditMode={false}
        // promptFragmentsData={promptFragmentsData}
      />
      <PreviewSystemPromptsModal
        isOpen={isOpenSystemPrompsPreviewModal}
        onClose={() => setIsOpenSystemPromptsPreviewModal(false)}
      />
    </div>
  );
}

export default CardMenu;
